import { c as _c } from "react/compiler-runtime";
import styles from "@website/ui/avatar/avatar.module.scss";
import { AvatarPropertiesType } from "@website/ui/avatar/avatar.types";
import { LazyImage } from "@website/ui/lazy-image";
import { FC } from "react";
export const Avatar: FC<AvatarPropertiesType> = properties => {
  const $ = _c(9);
  const {
    variant: t0,
    color: t1,
    size: t2,
    type: t3,
    Icon,
    text,
    src,
    alt,
    className
  } = properties;
  const variant = t0 === undefined ? "rounded" : t0;
  const color = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "medium" : t2;
  const type = t3 === undefined ? "text" : t3;
  const t4 = `${styles.avatar} ${styles[variant]} ${styles[color]} ${styles[size]} ${styles[type]} ${className ?? ""} `;
  let t5;
  if ($[0] !== Icon || $[1] !== alt || $[2] !== src || $[3] !== text || $[4] !== type) {
    t5 = type === "text" ? <span>{text || ""}</span> : type === "icon" && Icon ? Icon : type === "image" && src ? <LazyImage alt={alt} src={src} /> : null;
    $[0] = Icon;
    $[1] = alt;
    $[2] = src;
    $[3] = text;
    $[4] = type;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};